import React, { Component } from 'react';
import Utils from '@/utils';
import ImageCutoutUploadSuccessRender from './children/ImageCutoutUploadSuccessRender';
import sentGAEvent from '@/ga';

import '@/assets/imageCutout.less';

class ImageCutoutUploadSuccessFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleDownload = () => {
    sentGAEvent({
      category: 'DownloadStart',
      action: '07BC_DownloadStart',
      label: 'Null',
    });
    sentGAEvent({
      category: 'BG_download',
      action: 'BG_download_click',
      label: 'result_page',
    });
    Utils.downloadFile(this.props.imageCutoutObj, 'png', 'cutoutfilename');
  };

  handleSubmit = () => {
    let imgFlag = Utils.handleImageCutoutTimes(this.props.pageType);
    if (imgFlag) {
      return false;
    }
    let videoFlag = Utils.handleVideoEditorTimes('07BC');
    if (videoFlag) {
      return false;
    }
    sentGAEvent({
      category: 'BG_add_files',
      action: 'BG_remove_click',
    });
    this.props.handleSubmit();
  };

  handleClose = () => {
    sentGAEvent({
      category: 'BG_add_files',
      action: 'BG_add_files_delete_click',
    });
    this.props.handleClose();
  };
  render() {
    return (
      <div>
        <ImageCutoutUploadSuccessRender
          imageCutoutObj={this.props.imageCutoutObj}
          submitting={this.props.submitting}
          handleSubmit={this.handleSubmit}
          handleDownload={this.handleDownload}
          handleShowEditor={this.props.handleShowEditor}
          handleClose={this.handleClose}
          cancelProcessCallBack={this.props.cancelRemoveProcessCallBack}
          pageType={this.props.pageType}
          base64={this.props.base64}
          calWidth={this.props.calWidth}
          calheight={this.props.calheight}
          preBase={this.props.preBase}
        />
      </div>
    );
  }
}

export default ImageCutoutUploadSuccessFunction;
